module.exports = __webpack_public_path__ + "0743811996836ea1956d9ca79cca53e6.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/icons/calculator.png
// module id = 612
// module chunks = 0